import { useState, useEffect, useRef } from 'react';
import './header.css';

const Header = () => {
  const [showmodal, setshowmodal] = useState(false);
  const modalRef = useRef(null);

  const [theme, setTheme] = useState(() => {
    return localStorage.getItem("currentMode") || "dark";
  });

  useEffect(() => {
    document.body.style.overflow = showmodal ? 'hidden' : 'auto';
  }, [showmodal]);

  useEffect(() => {
    document.body.classList.remove("light", "dark");
    document.body.classList.add(theme);
  }, [theme]);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") setshowmodal(false);
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, []);

  const handleBackdropClick = (e) => {
    if (modalRef.current && !modalRef.current.contains(e.target)) {
      setshowmodal(false);
    }
  };

  const toggleTheme = () => {
    const newTheme = theme === "dark" ? "light" : "dark";
    localStorage.setItem("currentMode", newTheme);
    setTheme(newTheme);
  };

  return (
    <header className="flex header-container">
      <button className="menu icon-menu" onClick={() => setshowmodal(true)}>
        ☰
      </button>

      <nav>
        <ul className="flex nav-list">
          <li><a href="#">About</a></li>
          <li><a href="#">Articles</a></li>
          <li><a href="#">Projects</a></li>
          <li><a href="#">Speaking</a></li>
          <li><a href="#">Contact</a></li>
        </ul>
      </nav>

      <button onClick={toggleTheme} className="theme-toggle">
        {theme === "dark" ? (
          <span className="fa fa-moon-o" aria-hidden="true"></span>
        ) : (
          <span className="fa fa-sun" aria-hidden="true"></span>
        )}
      </button>

      {showmodal && (
        <div className="fixed" onClick={handleBackdropClick}>
          <ul className="modal" ref={modalRef}>
            <li>
              <button className="icon-clear" onClick={() => setshowmodal(false)}>×</button>
            </li>
            <li><a href="#">About</a></li>
            <li><a href="#">Articles</a></li>
            <li><a href="#">Projects</a></li>
            <li><a href="#">Speaking</a></li>
            <li><a href="#">Uses</a></li>
          </ul>
        </div>
      )}
    </header>
  );
};

export default Header;
